import { render, staticRenderFns } from "./GedHistoricoPaginacao.vue?vue&type=template&id=aab2d5dc&scoped=true"
import script from "./GedHistoricoPaginacao.vue?vue&type=script&lang=js"
export * from "./GedHistoricoPaginacao.vue?vue&type=script&lang=js"
import style0 from "./GedHistoricoPaginacao.vue?vue&type=style&index=0&id=aab2d5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab2d5dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCardActions,VCol,VPagination,VRow,VSelect})
